import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      width: 320,
      display: 'flex',
      flexFlow: 'column nowrap',
      alignItems: 'center',

      paddingLeft: 20,
      paddingRight: 20,
      borderRadius: theme.shape.borderRadius,
      background: COLORS.neutral.white,
      boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.10), 0 4px 6px -4px rgba(0, 0, 0, 0.10)',

      [theme.breakpoints.up('sm')]: {
        width: 480,
        padding: theme.spacing(5),
      },
    },
    header: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2),
      marginBottom: theme.spacing(3),
    },
    title: {
      textAlign: 'center',
    },
    subtitle: {
      textAlign: 'center',
      whiteSpace: 'pre-wrap',
    },
  }),
  { name: 'UnauthenticatedPageContentPanel' }
);
